// extracted by mini-css-extract-plugin
export default {"heading":"ColumnNav_heading__NcnMT","listItem":"ColumnNav_listItem__gPL3g","anchor":"ColumnNav_anchor__74Co3"};